module.exports = __webpack_public_path__ + "img/Weapon_170.d38d7822.png";